export default __webpack_public_path__ + "static/media/search.854d45e5.svg";